import { Buffer } from 'buffer';
import process from 'process/browser';
const globalObject = window;
if (!globalObject.global) {
  globalObject.global = globalObject;
}
if (!globalObject.Buffer) {
  globalObject.Buffer = Buffer;
}
if (!globalObject.process) {
  globalObject.process = process;
}